<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "ddd" },
    _vm._l(_vm.items, function (item) {
      return _c(_vm.resolveNavItemComponent(item), {
        key: _vm.$t(item.header) || _vm.$t(item.title),
        tag: "component",
        attrs: { item: item },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-items/VerticalNavMenuItems.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import core_layouts_utils from '@core/layouts/utils';
import * as vue_composition_api from '@vue/composition-api';
import vertical_nav_menu_header from '../vertical-nav-menu-header';
import vertical_nav_menu_link_VerticalNavMenuLink_vue from '../vertical-nav-menu-link/VerticalNavMenuLink.vue';
import vertical_nav_menu_group_VerticalNavMenuGroup_vue from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue';
//
//
//
//
//
//
//
//
//
//
//






export default ({
  render,
  staticRenderFns,
  components: {
    VerticalNavMenuHeader: vertical_nav_menu_header,
    VerticalNavMenuLink: vertical_nav_menu_link_VerticalNavMenuLink_vue,
    VerticalNavMenuGroup: vertical_nav_menu_group_VerticalNavMenuGroup_vue
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  setup() {
    vue_composition_api.provide("openGroups", vue_composition_api.ref([]));
    return {
      resolveNavItemComponent: core_layouts_utils["resolveVerticalNavMenuItemComponent"]
    };
  }
});

//# sourceURL=webpack:///./src/@core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-items/VerticalNavMenuItems.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

